module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "special-topic-detail"
  }, [_c('xi-top'), _vm._v(" "), _c('div', {
    staticClass: "topic-banner",
    style: ({
      backgroundImage: 'url(' + _vm.imgPath + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "guide-block-wrapper"
  }, [_c('div', {
    staticClass: "guide-block-inner-wrapper"
  }, [(_vm.data.guideTitle) ? _c('span', {
    staticClass: "guide-title"
  }, [_vm._v(_vm._s(_vm.data.guideTitle))]) : _vm._e(), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.data.guideContent)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "topic-block-wrapper"
  }, [_c('div', {
    staticClass: "topic-block-inner-wrapper"
  }, [_c('span', {
    staticClass: "topic-title"
  }, [_vm._v(_vm._s(_vm.data.majorTitle))]), _vm._v(" "), _vm._l((_vm.data.majorRequirement), function(topic) {
    return _c('div', {
      key: topic.id,
      staticClass: "topic-block"
    }, [(topic.authorType === 'author') ? _c('div', {
      key: "topic.id",
      staticClass: "topic-group-author-wrapper"
    }, [_c('img', {
      attrs: {
        "src": ("" + (_vm.$store.state.UPLOAD_IMG_HOST) + (topic.logo))
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "author-content"
    }, [_c('span', {
      staticClass: "author-title"
    }, [_vm._v(_vm._s(topic.name))]), _vm._v(" "), _c('p', {
      staticClass: "author-desc"
    }, [_vm._v(_vm._s(topic.description))])])]) : _vm._e(), _vm._v(" "), (topic.authorType === 'press') ? _c('div', {
      key: "topic.id",
      staticClass: "topic-group-press-wrapper"
    }, [_c('img', {
      attrs: {
        "src": ("" + (_vm.$store.state.UPLOAD_IMG_HOST) + (topic.logo))
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "press-content"
    }, [_c('span', {
      staticClass: "press-title"
    }, [_vm._v(_vm._s(topic.name))]), _vm._v(" "), _c('p', {
      staticClass: "press-desc"
    }, [_vm._v(_vm._s(topic.description))])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "topic-work"
    }, [(topic.authorType) ? _c('span', {
      staticClass: "works-title"
    }, [_vm._v("优选作品")]) : _vm._e(), _vm._v(" "), _vm._l((topic.requirementList), function(work) {
      return _c('div', {
        key: work.requirementId,
        staticClass: "work-wrapper"
      }, [_c('a', {
        attrs: {
          "href": ((_vm.$store.state.A_PC_HOST) + "/requirement/" + (work.requirementId) + "/candidate")
        }
      }, [_c('img', {
        attrs: {
          "src": _vm.handleCover(work.coverPath)
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "work-content-wrapper"
      }, [_c('a', {
        staticClass: "work-title",
        attrs: {
          "href": ((_vm.$store.state.A_PC_HOST) + "/requirement/" + (work.requirementId) + "/candidate")
        }
      }, [_vm._v(_vm._s(work.requirementName))]), _vm._v(" "), _c('span', {
        staticClass: "work-author"
      }, [_vm._v(_vm._s(work.author) + " 著")]), _vm._v(" "), _c('span', {
        staticClass: "work-type"
      }, [_vm._v(_vm._s(work.categoryName))]), _vm._v(" "), _c('p', {
        staticClass: "work-desc"
      }, [_vm._v(_vm._s(work.description))]), _vm._v(" "), _c('div', {
        staticClass: "work-footer"
      }, [_c('div', {
        staticClass: "work-footer-left"
      }, [_c('span', {
        staticClass: "work-pay"
      }, [_vm._v(_vm._s(_vm.getPayLabel(work)))]), _vm._v(" "), _c('span', {
        staticClass: "work-pay-type"
      }, [_vm._v(_vm._s(_vm.getPayTypeLabel(work)))])]), _vm._v(" "), _c('div', {
        staticClass: "work-footer-right"
      }, [_c('span', {
        staticClass: "work-audition-time-remaining"
      }, [_vm._v(_vm._s(_vm.getRemainingLabel(work)))]), _vm._v(" "), _c('span', {
        staticClass: "work-audition-person-time"
      }, [_vm._v(_vm._s(work.candidateOrTaskWorkNum) + "人参选")]), _vm._v(" "), _c('a', {
        staticClass: "work-audition-btn",
        attrs: {
          "href": ((_vm.$store.state.A_PC_HOST) + "/requirement/" + (work.requirementId) + "/candidate")
        }
      }, [_vm._v("去参加海选")])])])])])
    })], 2)])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "sub-topic-block-wrapper"
  }, [_c('div', {
    staticClass: "sub-topic-block-inner-wrapper"
  }, [_c('span', {
    staticClass: "sub-topic-title"
  }, [_vm._v(_vm._s(_vm.data.moreTitle))]), _vm._v(" "), _c('div', {
    staticClass: "sub-topic-works-wrapper"
  }, _vm._l((_vm.data.moreRequirement.requirementList), function(work) {
    return _c('a', {
      key: work.requirementId,
      staticClass: "sub-topic-work-wrapper",
      attrs: {
        "href": ((_vm.$store.state.A_PC_HOST) + "/requirement/" + (work.requirementId) + "/candidate")
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.handleCover(work.coverPath)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "sub-topic-work-content-wrapper"
    }, [_c('div', {
      staticClass: "sub-topic-work-first"
    }, [_c('span', {
      staticClass: "sub-topic-work-pay"
    }, [_vm._v(_vm._s(_vm.getPayLabel(work)))]), _vm._v(" "), _c('span', {
      staticClass: "sub-topic-work-pay-type"
    }, [_vm._v(_vm._s(_vm.getPayTypeLabel(work)))])]), _vm._v(" "), _c('span', {
      staticClass: "sub-topic-work-second"
    }, [_vm._v(_vm._s(work.requirementName))]), _vm._v(" "), _c('span', {
      staticClass: "sub-topic-work-third"
    }, [_vm._v(_vm._s(work.author) + " 著")]), _vm._v(" "), _c('span', {
      staticClass: "sub-topic-work-fourth"
    }, [_vm._v(_vm._s(work.categoryName))]), _vm._v(" "), _c('div', {
      staticClass: "sub-topic-work-fifth"
    }, [_c('span', {
      staticClass: "sub-topic-audition-time-remaining"
    }, [_vm._v(_vm._s(_vm.getRemainingLabel(work)))]), _vm._v(" "), _c('span', {
      staticClass: "sub-topic-audition-person-time"
    }, [_vm._v(_vm._s(work.candidateOrTaskWorkNum) + "人参选")])])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "topic-detail-footer-wrapper"
  }, [_c('div', {
    staticClass: "topic-detail-footer-inner-wrapper"
  }, [_c('a', {
    staticClass: "more-block more-requirement",
    attrs: {
      "href": ((_vm.$store.state.A_PC_HOST) + "/requirementview")
    }
  }, [_c('span', [_vm._v("没看够？查看所有海选任务")]), _vm._v(" "), _c('span', {
    staticClass: "go"
  }, [_vm._v("GO")])]), _vm._v(" "), _c('router-link', {
    staticClass: "more-block topic-list",
    attrs: {
      "to": {
        name: 'specialTopicList'
      }
    }
  }, [_c('span', [_vm._v("更多精品专题在这里")]), _vm._v(" "), _c('span', {
    staticClass: "go"
  }, [_vm._v("GO")])])], 1)]), _vm._v(" "), _c('xi-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cd5ca5d0!./~/vue-loader/lib/selector.js?type=template&index=0!./views/specialTopic/Detail.vue
// module id = 1119
// module chunks = 0